import request from 'lmcv/utils/axios'
import { API_ENDPOINTS } from 'lmcv/modules/endpoints'

export const getSignUpInformation = async (region) => {
  const response = await request
    .get(API_ENDPOINTS.signUpInformation(region))
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
